import { DataBadge } from "./Badges";

/**
 * KPICard - clearly separates REAL metrics from Nadia estimates.
 * Never mix visually.
 */
export function KPICard({ label, value, unit, variant = "real", helper, icon: Icon, testId }) {
  return (
    <div
      className="nadia-card p-4 sm:p-5 flex flex-col gap-3"
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs text-slate-400 font-medium uppercase tracking-wider">
          {label}
        </span>
        {Icon ? (
          <span className="text-slate-500">
            <Icon size={16} strokeWidth={1.75} />
          </span>
        ) : null}
      </div>
      <div className="flex items-baseline gap-1.5">
        <span className="font-heading text-2xl sm:text-3xl font-bold text-slate-50">
          {value}
        </span>
        {unit ? (
          <span className="text-sm text-slate-400 font-medium">{unit}</span>
        ) : null}
      </div>
      <div className="flex items-center justify-between">
        <DataBadge variant={variant} />
        {helper ? (
          <span className="text-xs text-slate-500">{helper}</span>
        ) : null}
      </div>
    </div>
  );
}
